import { type AutocompletePlugin } from "@algolia/autocomplete-core";
import Fuse from "fuse.js";

type SearchableCategory = StaticCategory & {
    slug: string;
    cleanDescription: string;
};
const stripHtml = (html: string) =>
    html.replace(/<[^>]*>/g, "");

const createFuse = (categoryData: StaticCategoryMap) => {
    const list: SearchableCategory[] = Object.entries(categoryData).map(
        ([slug, cat]) =>{
			return {
				// @ts-ignore
				...cat,
				slug,
				cleanDescription: stripHtml(cat.description),
			};
		}
    );

    return new Fuse(list, {
        keys: [
            { name: "name", weight: 0.7 },
            { name: "cleanDescription", weight: 0.3 },
        ],
        threshold: 0.35,
        ignoreLocation: true,
        minMatchCharLength: 2,
        includeMatches: true,
    });
};
const highlightMatch = (text: string, query: string) => {
    if (!query) return text;
    const escapedQuery = query.replace(/[-/^$*+?.()|[\]{}]/g, "\\$&"); // escape regex chars
    const regex = new RegExp(`(${escapedQuery})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
};

export const useStaticCategoriesPlugin = (categoryData: StaticCategoryMap, autocompleteSuggestionsHits: number) => {
   console.log(categoryData);
    const fuse = createFuse(categoryData);
    const categoriesPlugin: AutocompletePlugin<SearchableCategory, {}> = {
        getSources({ query }) {
			if (!query) {
				return [];
			}
			return [
				{
					sourceId: "staticCategoriesPlugin",
					getItems() {
                        const results = fuse.search(query, { limit: autocompleteSuggestionsHits });

                        return results.slice(0, autocompleteSuggestionsHits).map(({ item, matches }) => {
                            const nameMatch = matches?.find(
                                (m) => m.key === "name"
                            );

                            return {
                                ...item,
                                highlightedName: nameMatch
                                    ? highlightMatch(item.name, query)
                                    : item.name,
                            };
                        });
					},
				},
			];
		},
	};
	return categoriesPlugin;
};
